import gb from './gb'

const vocab = {
  'gb': gb
}

export default (locale, str) => vocab[locale][str]



// WEBPACK FOOTER //
// ./src/modules/quote/i18n/i18n.js